
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  CalendarModule,
  DataTableModule,
  ListboxModule,
  MultiSelectModule,
  StepsModule,
  MenuModule,
  GrowlModule,
  MessagesModule,
  AutoCompleteModule,
  DropdownModule,
  EditorModule,
  InputTextModule,
  ChipsModule,
  DialogModule,
  TooltipModule,
  ContextMenuModule,
} from 'primeng/primeng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';

import { ReleaseBundleComponent } from './release-bundle.component';

import { ReleaseBundleService } from './release-bundle.service';

import { ReleaseBundleRoutingModule } from './release-bundle-routing.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    BrowserAnimationsModule,
    DataTableModule,
    ListboxModule,
    MultiSelectModule,
    StepsModule,
    MenuModule,
    GrowlModule,
    MessagesModule,
    AutoCompleteModule,
    DropdownModule,
    EditorModule,
    InputTextModule,
    ChipsModule,
    DialogModule,
    TooltipModule,
    ReleaseBundleRoutingModule,
    ConfirmDialogModule,
    ContextMenuModule,
    MatDialogModule
  ],
  declarations: [
  ],
  providers: [ReleaseBundleService, ConfirmationService],
  bootstrap: [ReleaseBundleComponent]
})
export class ReleaseBundleModule { }
